const {iframeResize} = require('iframe-resizer');


iframeResize({checkOrigin:false,heightCalculationMethod:'lowestElement'});
